import imageUrlBuilder from '@sanity/image-url';
import type { ImageUrlBuilder } from 'sanity';

import { getClientValidatedEnv } from '../../config/client-env';

class SanityUrlServiceImplementation {
  builder: ImageUrlBuilder | undefined = undefined;

  urlFor(imageUrl: string) {
    if (this.builder === undefined) {
      this.builder = imageUrlBuilder({
        projectId:
          getClientValidatedEnv().NEXT_PUBLIC_SANITY_WORKSPACE ??
          getClientValidatedEnv().SANITY_STUDIO_WORKSPACE,
        dataset:
          getClientValidatedEnv().NEXT_PUBLIC_SANITY_DATASET ??
          getClientValidatedEnv().SANITY_STUDIO_DATASET,
      });
    }
    return this.builder.image(imageUrl);
  }

  removeParamsFromUrl(imageUrl: string): string {
    return imageUrl.split('?')[0]!;
  }
}

export const SanityUrlService = new SanityUrlServiceImplementation();
